import type {
  CreateLocation,
  GetLocationResponse,
  LocationGetAllResponse,
  LocationSearchParams,
  UpdateLocation,
} from '@quromedical/models';
import { trpcClient } from 'trpc';

export class LocationApi {
  public createLocation = async (
    location: CreateLocation,
  ): Promise<Partial<GetLocationResponse>> => {
    const result = await trpcClient.location.create.mutate(location);

    return result;
  };

  public getAllLocations = async (
    params: LocationSearchParams = {},
  ): Promise<LocationGetAllResponse> => {
    const result = await trpcClient.location.getAll.query(params);

    return result;
  };

  public getLocation = async (id: string): Promise<GetLocationResponse> => {
    const result = await trpcClient.location.getById.query({ id });

    return result;
  };

  public updateLocation = async (
    location: UpdateLocation,
  ): Promise<Partial<GetLocationResponse>> => {
    const result = await trpcClient.location.update.mutate(location);

    return result;
  };
}
